import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { logUsage } from 'owa-analytics';
import { makeGetRequest } from 'owa-ows-gateway';
import { setIsReadOnly } from 'owa-mail-store/lib/actions/setIsReadOnly';

const CLP_LABEL_ENDPOINT_URI = '/compliancepolicy/api/v1.0/user/label';

let processedCLPLabelResponse: boolean | null = null;

function processCLPLabelResponse(CLPResponse) {
    const { value } = CLPResponse;
    let hasMandatoryLabel: boolean = false;
    let hasMandatoryTeamworkLabel: boolean = false;
    let hasDefault: boolean = false;
    let hasDefaultTeamwork: boolean = false;
    let isAutoLabelingOn: boolean = false;
    try {
        value.forEach(label => {
            if (
                !(label.PolicySetting_disablemandatoryinoutlook?.toLowerCase() == 'true') &&
                !hasMandatoryLabel &&
                label.PolicySetting_mandatory?.toLowerCase() == 'true'
            ) {
                hasMandatoryLabel = true;
            }
            if (
                !hasMandatoryTeamworkLabel &&
                label.PolicySetting_teamworkmandatory?.toLowerCase() == 'true'
            ) {
                const labelContentType = label.Setting_contenttype
                    ? label.Setting_contenttype?.toLowerCase()
                          .split(',')
                          .map(type => type.trim())
                    : [];
                if (
                    labelContentType?.length > 0 &&
                    labelContentType.indexOf('Calendar') != -1 //todo: check if this is correct
                ) {
                    hasMandatoryTeamworkLabel = true;
                }
            }
            hasDefault =
                hasDefault ||
                (label.PolicySetting_outlookdefaultlabel &&
                    label.PolicySetting_outlookdefaultlabel.length > 0)
                    ? label.PolicySetting_outlookdefaultlabel?.toLowerCase() == 'none'
                        ? false
                        : label.PolicySetting_outlookdefaultlabel == label.Id
                    : label.PolicySetting_default?.toLowerCase() == 'true';
            hasDefaultTeamwork =
                hasDefaultTeamwork ||
                (label.PolicySetting_teamworkdefaultlabelid &&
                    label.PolicySetting_teamworkdefaultlabelid.length > 0)
                    ? label.PolicySetting_teamworkdefaultlabelid == label.Id
                    : false;
            isAutoLabelingOn =
                label.AutoLabeling_SensitiveTypeIds &&
                label.AutoLabeling_SensitiveTypeIds.length > 0;
        });
    } catch (e) {
        console.error('Error processing CLP label response', e);
        logUsage('readOnlyProcessingError', {}, { isCore: true });
    }
    processedCLPLabelResponse = !!(
        hasMandatoryLabel ||
        hasMandatoryTeamworkLabel ||
        hasDefault ||
        hasDefaultTeamwork ||
        isAutoLabelingOn
    ); //Use !! to force undefined to be a false value
}

export const loadCLPUserLabels = (): void => {
    if (!processedCLPLabelResponse) {
        if (!isConsumer()) {
            makeGetRequest(
                CLP_LABEL_ENDPOINT_URI,
                undefined /* CorrellationId  */,
                false /* ReturnFullRequest */,
                {
                    SupportedMaxVersion: '1.0.48.0',
                    Capabilities: 'SMIME',
                } /* CustomHeader */,
                undefined /* throwServiceError */,
                undefined /* includeCredentials */,
                undefined /* actionName */
            ).then(resp => {
                processCLPLabelResponse(resp);
                logUsage('isMiniReadOnly', { isRO: processedCLPLabelResponse }, { isCore: true });
                setIsReadOnly(processedCLPLabelResponse);
            });
        } else {
            setIsReadOnly(false);
        }
    }
    setIsReadOnly(processedCLPLabelResponse);
};
